import React, { useState, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { navigate } from '@reach/router';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import { Title } from '../../atoms/Title';
import { Button } from '../../atoms/Button';
import { Container } from '../../atoms/Container';
import { Text } from '../../atoms/Text';
import {
    cleanLoginExpirado,
    novaPermissoes
} from '../../../redux/actions/loginActions';

export default function Alert() {
    const [open, setOpen] = useState(false);
    const alert = useSelector(state => state.alert);
    const dispatch = useDispatch();

    const handleClose = () => {
        if (alert.extraMensagem === 'LOGOUT') {
            navigate(`${process.env.REACT_APP_BASE_URL}login`);
        }
        if (alert.customClose) {
            alert.customClose();
        }
        setOpen(false);
    };

    useEffect(() => {
        if (alert && alert.titulo) {
            if (alert.extraMensagem) {
                if (alert.extraMensagem === 'LOGOUT') {
                    dispatch(cleanLoginExpirado());
                } else if (alert.extraMensagem.key === 405) {
                    dispatch(novaPermissoes(alert.extraMensagem.permissoes));
                }
            }
            setOpen(true);
        }
    }, [alert, alert.titulo, dispatch]);

    return (
        <>
            {alert && alert.titulo && (
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby='form-dialog-title'
                >
                    <Container>
                        <Title
                            id='form-dialog-title'
                            type='h3'
                            themecolor='primary'
                            align='center'
                        >
                            {alert.titulo}
                        </Title>
                        {alert.conteudo && (
                            <Container>
                                {alert.conteudo.map(element => {
                                    if (element) {
                                        return (
                                            <Text align='center' key={element}>
                                                {element}
                                            </Text>
                                        );
                                    }
                                    return <div key='semConteudo' />;
                                })}
                            </Container>
                        )}
                        <DialogActions>
                            {alert.botoes ? (
                                alert.botoes.map(element => (
                                    <Button
                                        onClick={event => {
                                            handleClose();
                                            element.click &&
                                                element.click(event);
                                        }}
                                        key={element.texto}
                                        width='initial'
                                        {...element.props}
                                    >
                                        {element.texto}
                                    </Button>
                                ))
                            ) : (
                                <>
                                    <Button
                                        onClick={handleClose}
                                        width='initial'
                                    >
                                        Voltar
                                    </Button>
                                </>
                            )}
                        </DialogActions>
                    </Container>
                </Dialog>
            )}
        </>
    );
}
